/**
 * contains the abi and contract address
*/

class GuildsContract {
    constructor() {
        this.abi = [
	{
		"constant": true,
		"inputs": [
			{
				"internalType": "uint32",
				"name": "i",
				"type": "uint32"
			}
		],
		"name": "getGuildForSelf",
		"outputs": [
			{
				"internalType": "uint32",
				"name": "",
				"type": "uint32"
			}
		],
		"payable": false,
		"stateMutability": "view",
		"type": "function"
	},
	{
		"constant": true,
		"inputs": [
			{
				"internalType": "address",
				"name": "user",
				"type": "address"
			}
		],
		"name": "getTotalGuildsForUser",
		"outputs": [
			{
				"internalType": "uint256",
				"name": "",
				"type": "uint256"
			}
		],
		"payable": false,
		"stateMutability": "view",
		"type": "function"
	},
	{
		"constant": false,
		"inputs": [
			{
				"internalType": "bytes32[6]",
				"name": "guildPublicKey",
				"type": "bytes32[6]"
			},
			{
				"internalType": "string",
				"name": "name",
				"type": "string"
			},
			{
				"internalType": "bytes32",
				"name": "encryptedKeyIpfsHash",
				"type": "bytes32"
			},
			{
				"internalType": "bytes32[9]",
				"name": "contentKey",
				"type": "bytes32[9]"
			},
			{
				"internalType": "bytes32[6]",
				"name": "userPublicKey",
				"type": "bytes32[6]"
			}
		],
		"name": "newGuild",
		"outputs": [
			{
				"internalType": "uint32",
				"name": "",
				"type": "uint32"
			}
		],
		"payable": false,
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"constant": false,
		"inputs": [
			{
				"internalType": "uint32",
				"name": "guildId",
				"type": "uint32"
			}
		],
		"name": "rejectRequestToAddToGuild",
		"outputs": [],
		"payable": false,
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"constant": false,
		"inputs": [
			{
				"internalType": "uint32",
				"name": "guildId",
				"type": "uint32"
			},
			{
				"internalType": "bytes32[6]",
				"name": "publicKey",
				"type": "bytes32[6]"
			}
		],
		"name": "setPublicKeyForGuild",
		"outputs": [],
		"payable": false,
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"constant": true,
		"inputs": [
			{
				"internalType": "uint32",
				"name": "guildId",
				"type": "uint32"
			},
			{
				"internalType": "address",
				"name": "member",
				"type": "address"
			}
		],
		"name": "isGuildMember",
		"outputs": [
			{
				"internalType": "bool",
				"name": "",
				"type": "bool"
			}
		],
		"payable": false,
		"stateMutability": "view",
		"type": "function"
	},
	{
		"constant": false,
		"inputs": [
			{
				"internalType": "uint32",
				"name": "guildId",
				"type": "uint32"
			},
			{
				"internalType": "address",
				"name": "potentialMember",
				"type": "address"
			},
			{
				"internalType": "bytes32",
				"name": "encryptedKeyIpfsHash",
				"type": "bytes32"
			},
			{
				"internalType": "bytes32[9]",
				"name": "contentKey",
				"type": "bytes32[9]"
			},
			{
				"internalType": "bytes32[6]",
				"name": "publicKey",
				"type": "bytes32[6]"
			}
		],
		"name": "requestToAddMember",
		"outputs": [],
		"payable": false,
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"constant": true,
		"inputs": [],
		"name": "getTotalGuildsForSelf",
		"outputs": [
			{
				"internalType": "uint256",
				"name": "",
				"type": "uint256"
			}
		],
		"payable": false,
		"stateMutability": "view",
		"type": "function"
	},
	{
		"constant": false,
		"inputs": [
			{
				"internalType": "uint32",
				"name": "guildId",
				"type": "uint32"
			}
		],
		"name": "acceptRequestToAddToGuild",
		"outputs": [],
		"payable": false,
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"constant": true,
		"inputs": [
			{
				"internalType": "address",
				"name": "user",
				"type": "address"
			},
			{
				"internalType": "uint32",
				"name": "i",
				"type": "uint32"
			}
		],
		"name": "getGuildForUser",
		"outputs": [
			{
				"internalType": "uint32",
				"name": "",
				"type": "uint32"
			}
		],
		"payable": false,
		"stateMutability": "view",
		"type": "function"
	},
	{
		"constant": true,
		"inputs": [
			{
				"internalType": "uint32",
				"name": "guildId",
				"type": "uint32"
			}
		],
		"name": "getTotalGuildUsers",
		"outputs": [
			{
				"internalType": "uint256",
				"name": "",
				"type": "uint256"
			}
		],
		"payable": false,
		"stateMutability": "view",
		"type": "function"
	},
	{
		"constant": true,
		"inputs": [
			{
				"internalType": "uint32",
				"name": "guildId",
				"type": "uint32"
			}
		],
		"name": "getGuildName",
		"outputs": [
			{
				"internalType": "string",
				"name": "",
				"type": "string"
			}
		],
		"payable": false,
		"stateMutability": "view",
		"type": "function"
	},
	{
		"constant": false,
		"inputs": [
			{
				"internalType": "uint32",
				"name": "guildId",
				"type": "uint32"
			},
			{
				"internalType": "string",
				"name": "name",
				"type": "string"
			}
		],
		"name": "setNameForGuild",
		"outputs": [],
		"payable": false,
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"constant": true,
		"inputs": [
			{
				"internalType": "uint32",
				"name": "guild",
				"type": "uint32"
			},
			{
				"internalType": "uint32",
				"name": "i",
				"type": "uint32"
			}
		],
		"name": "getUserFromGuild",
		"outputs": [
			{
				"internalType": "address",
				"name": "",
				"type": "address"
			}
		],
		"payable": false,
		"stateMutability": "view",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "address",
				"name": "encryptionContractAddress",
				"type": "address"
			}
		],
		"payable": false,
		"stateMutability": "nonpayable",
		"type": "constructor"
	},
	{
		"anonymous": false,
		"inputs": [
			{
				"indexed": true,
				"internalType": "address",
				"name": "",
				"type": "address"
			},
			{
				"indexed": true,
				"internalType": "uint32",
				"name": "",
				"type": "uint32"
			},
			{
				"indexed": false,
				"internalType": "string",
				"name": "name",
				"type": "string"
			}
		],
		"name": "NewGuild",
		"type": "event"
	},
	{
		"anonymous": false,
		"inputs": [
			{
				"indexed": true,
				"internalType": "address",
				"name": "",
				"type": "address"
			},
			{
				"indexed": true,
				"internalType": "uint32",
				"name": "",
				"type": "uint32"
			}
		],
		"name": "NewGuildMember",
		"type": "event"
	},
	{
		"anonymous": false,
		"inputs": [
			{
				"indexed": true,
				"internalType": "address",
				"name": "",
				"type": "address"
			},
			{
				"indexed": true,
				"internalType": "address",
				"name": "",
				"type": "address"
			},
			{
				"indexed": true,
				"internalType": "uint32",
				"name": "",
				"type": "uint32"
			}
		],
		"name": "NewGuildMemberRequest",
		"type": "event"
	},
	{
		"anonymous": false,
		"inputs": [
			{
				"indexed": true,
				"internalType": "address",
				"name": "",
				"type": "address"
			},
			{
				"indexed": true,
				"internalType": "uint32",
				"name": "",
				"type": "uint32"
			}
		],
		"name": "NewGuildMemberRequestAccepted",
		"type": "event"
	},
	{
		"anonymous": false,
		"inputs": [
			{
				"indexed": true,
				"internalType": "address",
				"name": "",
				"type": "address"
			},
			{
				"indexed": true,
				"internalType": "uint32",
				"name": "",
				"type": "uint32"
			}
		],
		"name": "NewGuildMemberRequestRejected",
		"type": "event"
	},
	{
		"anonymous": false,
		"inputs": [
			{
				"indexed": true,
				"internalType": "address",
				"name": "",
				"type": "address"
			},
			{
				"indexed": true,
				"internalType": "uint32",
				"name": "",
				"type": "uint32"
			}
		],
		"name": "GuildMemberLeft",
		"type": "event"
	},
	{
		"anonymous": false,
		"inputs": [
			{
				"indexed": true,
				"internalType": "uint32",
				"name": "",
				"type": "uint32"
			},
			{
				"indexed": true,
				"internalType": "bytes32[6]",
				"name": "",
				"type": "bytes32[6]"
			}
		],
		"name": "GuildPublicKeyChanged",
		"type": "event"
	},
	{
		"anonymous": false,
		"inputs": [
			{
				"indexed": true,
				"internalType": "address",
				"name": "",
				"type": "address"
			},
			{
				"indexed": true,
				"internalType": "uint32",
				"name": "",
				"type": "uint32"
			},
			{
				"indexed": true,
				"internalType": "bytes32",
				"name": "",
				"type": "bytes32"
			}
		],
		"name": "GuildKeyEncrypted",
		"type": "event"
	}
        ];

        this.contractAddress = '0x70548646c2A475ebfE46F19637651e76a38324d4';
    }

    getContract(web3) {
        return new web3.eth.Contract(this.abi, this.contractAddress);
    }
}

export default GuildsContract;
